/* Aensō homepage: drawers, live bag (Shopify AJAX Cart API), add to bag, kit builder, sign-up. */
(() => {
  const cfg = window.aeConfig || {};
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  function money(cents) {
    const fmt = cfg.moneyFormat || '£{{amount}}';
    const n = (cents || 0) / 100;
    const two = n.toFixed(2);
    const withCommas = (v) => v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      if (key === 'amount_no_decimals') return withCommas(Math.round(n).toString());
      if (key === 'amount_with_comma_separator') return two.replace('.', ',');
      return withCommas(two.split('.')[0]) + '.' + two.split('.')[1];
    });
  }

  /* ---------- Drawers ---------- */
  let lastFocus = null;
  function openDrawer(id) {
    $$('[data-ae-drawer].is-open').forEach((d) => d.id !== id && closeDrawer(d, false));
    const d = document.getElementById(id);
    if (!d) return;
    lastFocus = lastFocus || document.activeElement;
    d.classList.add('is-open');
    document.body.classList.add('ae-locked');
    $$(`[aria-controls="${id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
    hideToast();
    if (id === 'ae-bag') refreshCart();
    const first = $('.ae-x', d);
    first && first.focus();
  }
  function closeDrawer(d, restore = true) {
    d.classList.remove('is-open');
    $$(`[aria-controls="${d.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (!$('[data-ae-drawer].is-open')) {
      document.body.classList.remove('ae-locked');
      if (restore && lastFocus) { lastFocus.focus(); lastFocus = null; }
    }
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-ae-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.dataset.aeOpen); return; }
    const closer = e.target.closest('[data-ae-close]');
    if (closer) { closeDrawer(closer.closest('[data-ae-drawer]')); return; }
    const link = e.target.closest('[data-ae-close-link]');
    if (link) { const d = link.closest('[data-ae-drawer]'); d && closeDrawer(d, false); }
  });
  document.addEventListener('keydown', (e) => {
    const open = $('[data-ae-drawer].is-open');
    if (!open) return;
    if (e.key === 'Escape') { closeDrawer(open); return; }
    if (e.key === 'Tab') {
      const f = $$('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])', open).filter((el) => el.offsetParent !== null);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg) {
    const t = $('[data-ae-toast]');
    if (!t || $('#ae-bag.is-open')) return;
    $('[data-ae-toast-msg]', t).textContent = msg;
    t.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 2600);
  }
  function hideToast() { const t = $('[data-ae-toast]'); if (t) t.hidden = true; }

  /* ---------- Cart ---------- */
  const bag = $('#ae-bag');
  let upsellData = [];
  try { upsellData = JSON.parse(($('[data-ae-upsell-data]') || {}).textContent || '[]'); } catch (_) {}

  async function cartRequest(url, body) {
    const res = await fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.description || data.message || 'Something went wrong');
    return data;
  }
  const getCart = () => cartRequest(`${cfg.routes?.cart || '/cart'}.js`);

  function renderCart(cart) {
    $$('[data-ae-count]').forEach((el) => { el.textContent = cart.item_count; });
    $$('[data-ae-bag-label]').forEach((el) => el.setAttribute('aria-label', `Bag, ${cart.item_count} item${cart.item_count === 1 ? '' : 's'}`));
    if (!bag) return;
    const has = cart.item_count > 0;
    $('[data-ae-empty]', bag).hidden = has;
    $('[data-ae-items]', bag).hidden = !has;
    $('[data-ae-foot]', bag).hidden = !has;

    $('[data-ae-lines]', bag).innerHTML = cart.items.map((item, i) => {
      const img = item.image ? `${item.image}${item.image.includes('?') ? '&' : '?'}width=240` : '';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      const [first, ...rest] = (item.product_title || '').split(' ');
      const desc = [rest.join(' '), variant].filter(Boolean).join(' · ');
      const was = item.original_line_price > item.final_line_price ? `<span class="ae-line__was">${money(item.original_line_price)}</span>` : '';
      return `<div class="ae-line">
        <a href="${esc(item.url)}" class="ae-line__img">${img ? `<img class="ae-bottle" src="${esc(img)}" alt="" loading="lazy">` : ''}</a>
        <div class="ae-line__body">
          <div class="ae-line__top"><a href="${esc(item.url)}" class="ae-line__name">${esc(first)}</a><span class="ae-line__price">${was}${money(item.final_line_price)}</span></div>
          <span class="ae-line__desc">${esc(desc)}</span>
          <div class="ae-line__ctrl">
            <div class="ae-qty">
              <button type="button" aria-label="Decrease quantity of ${esc(item.product_title)}" data-ae-qty="${i + 1}" data-q="${item.quantity - 1}">−</button>
              <span>${item.quantity}</span>
              <button type="button" aria-label="Increase quantity of ${esc(item.product_title)}" data-ae-qty="${i + 1}" data-q="${item.quantity + 1}">+</button>
            </div>
            <button type="button" class="ae-remove" data-ae-qty="${i + 1}" data-q="0">Remove</button>
          </div>
        </div>
      </div>`;
    }).join('');

    const inBag = new Set(cart.items.map((i) => i.product_id));
    const ups = upsellData.filter((u) => !inBag.has(u.productId)).slice(0, 2);
    const upWrap = $('[data-ae-upsell]', bag);
    upWrap.hidden = ups.length === 0;
    $('[data-ae-upsell-grid]', bag).innerHTML = ups.map((u) => `<div class="ae-upsell__item">
        <span class="ae-upsell__img">${u.image ? `<img class="ae-bottle" src="${esc(u.image)}" alt="" loading="lazy">` : ''}</span>
        <div class="ae-upsell__foot"><span><span class="ae-upsell__name">${esc(u.name)}</span><span class="ae-upsell__price">${money(u.price)}</span></span>
        <button type="button" class="ae-add" aria-label="Add ${esc(u.name)} to bag" data-ae-add="${u.variantId}" data-ae-label="${esc(u.name)} added to bag">+</button></div>
      </div>`).join('');

    $('[data-ae-subtotal]', bag).textContent = money(cart.total_price);
    const saved = cart.total_discount || 0;
    const note = $('[data-ae-discount-note]', bag);
    note.hidden = saved <= 0;
    if (saved > 0) note.textContent = `You're saving ${money(saved)}.`;

    const threshold = cfg.freeShippingThreshold || 0;
    const msg = $('[data-ae-ship-msg]', bag);
    const bar = $('[data-ae-ship-bar]', bag);
    const line = $('[data-ae-ship-line]', bag);
    if (threshold > 0) {
      const left = threshold - cart.total_price;
      if (left <= 0) { if (msg) msg.textContent = 'Free UK shipping unlocked'; line.textContent = 'Free standard delivery'; }
      else { if (msg) msg.textContent = `${money(left)} away from free UK shipping`; line.textContent = 'Calculated at checkout'; }
      if (bar) bar.style.width = `${Math.min(100, Math.round((cart.total_price / threshold) * 100))}%`;
    } else {
      line.textContent = 'Free standard delivery';
    }
  }

  async function refreshCart() {
    try { renderCart(await getCart()); } catch (_) {}
  }

  async function addItems(items, label, btn) {
    if (btn) btn.disabled = true;
    try {
      await cartRequest(`${cfg.routes?.cartAdd || '/cart/add'}.js`, { items });
      const cart = await getCart();
      renderCart(cart);
      openDrawer('ae-bag');
    } catch (err) {
      toast(err.message);
    } finally {
      if (btn) btn.disabled = false;
    }
  }

  document.addEventListener('click', async (e) => {
    const add = e.target.closest('[data-ae-add]');
    if (add) {
      e.preventDefault();
      addItems([{ id: Number(add.dataset.aeAdd), quantity: 1 }], add.dataset.aeLabel, add);
      return;
    }
    const qty = e.target.closest('[data-ae-qty]');
    if (qty && bag) {
      bag.classList.add('is-busy');
      try {
        const cart = await cartRequest(`${cfg.routes?.cartChange || '/cart/change'}.js`, { line: Number(qty.dataset.aeQty), quantity: Math.max(0, Number(qty.dataset.q)) });
        renderCart(cart);
      } catch (err) {
        toast(err.message);
        refreshCart();
      } finally {
        bag.classList.remove('is-busy');
      }
    }
  });

  /* ---------- Kit builder ---------- */
  const kit = $('[data-ae-kit]');
  if (kit) {
    const rows = $$('[data-ae-kit-row]', kit);
    const bars = $$('[data-ae-kit-bar]', kit);
    const tabs = $$('[data-ae-kit-tab]', kit);
    const list = $('[data-ae-kit-list]', kit);
    const img = $('[data-ae-kit-img]', kit);
    const discount = Number(cfg.kitDiscount) || 0;
    const minItems = Number(cfg.kitMinItems) || 3;
    let active = null;

    const selected = () => rows.filter((r) => r.getAttribute('aria-pressed') === 'true' && !r.disabled);

    function show(row) {
      if (!row) return;
      active = row;
      const src = row.dataset.img;
      if (img && src && img.getAttribute('src') !== src) {
        img.style.opacity = '0';
        const next = new Image();
        next.onload = () => { if (active === row) { img.src = src; img.style.opacity = '1'; } };
        next.src = src;
      }
      $('[data-ae-kit-show-step]', kit).textContent = row.dataset.step;
      $('[data-ae-kit-show-name]', kit).textContent = row.dataset.name;
    }

    function update() {
      const sel = selected();
      rows.forEach((r) => r.classList.toggle('is-on', r.getAttribute('aria-pressed') === 'true' && !r.disabled));
      bars.forEach((b, i) => b.classList.toggle('is-on', i < sel.length));
      const sum = sel.reduce((a, r) => a + Number(r.dataset.price || 0), 0);
      const disc = discount > 0 && sel.length >= minItems;
      // Discount per item, rounded to the penny, the way Shopify allocates it at checkout
      const total = disc ? sel.reduce((a, r) => { const p = Number(r.dataset.price || 0); return a + p - Math.round(p * discount / 100); }, 0) : sum;
      $('[data-ae-kit-total]', kit).textContent = money(total);
      $('[data-ae-kit-was]', kit).textContent = disc ? money(sum) : '';
      const note = $('[data-ae-kit-note]', kit);
      const n = `${sel.length} selected`;
      if (discount <= 0) note.textContent = n;
      else if (disc) note.textContent = `${n} · ${discount}% off applied · You save ${money(sum - total)}`;
      else note.textContent = `${n} · Add ${minItems - sel.length} more to save ${discount}%`;
      const btn = $('[data-ae-kit-add]', kit);
      btn.textContent = sel.length ? `Add ${sel.length} ${sel.length === 1 ? 'item' : 'items'} to bag` : 'Select products';
      btn.disabled = sel.length === 0;
    }

    rows.forEach((row) => row.addEventListener('click', () => {
      if (row.disabled) return;
      const on = row.getAttribute('aria-pressed') !== 'true';
      row.setAttribute('aria-pressed', String(on));
      if (on) show(row);
      else if (active === row) show(selected()[0] || row);
      update();
    }));

    tabs.forEach((tab) => tab.addEventListener('click', () => {
      const t = tab.dataset.aeKitTab;
      tabs.forEach((x) => x.setAttribute('aria-pressed', String(x === tab)));
      rows.forEach((r) => { r.hidden = t !== 'all' && !r.dataset.cats.split(' ').includes(t); });
      if (list) list.scrollTop = 0;
    }));

    $('[data-ae-kit-add]', kit).addEventListener('click', (e) => {
      const sel = selected();
      if (!sel.length) return;
      addItems(sel.map((r) => ({ id: Number(r.dataset.variant), quantity: 1 })), 'Kit added to bag', e.currentTarget);
    });

    show(selected()[0] || rows.find((r) => !r.disabled));
    update();
  }

  /* ---------- Sign-up (Klaviyo list if configured, else Shopify customer form) ---------- */
  const news = $('#ae-news-form');
  if (news && news.dataset.aeNews) {
    news.addEventListener('submit', async (e) => {
      e.preventDefault();
      const email = $('input[type="email"]', news).value.trim();
      const btn = $('button[type="submit"]', news);
      btn.disabled = true;
      try {
        const res = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(news.dataset.aeCompany)}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
          body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'Homepage sign-up', profile: { data: { type: 'profile', attributes: { email } } } }, relationships: { list: { data: { type: 'list', id: news.dataset.aeNews } } } } })
        });
        if (!res.ok) throw new Error();
        news.hidden = true;
        $('[data-ae-news-done]').hidden = false;
      } catch (_) {
        news.submit();
      } finally {
        btn.disabled = false;
      }
    });
  }

  /* ---------- Copy discount code ---------- */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-ae-copy]');
    if (!b) return;
    try { await navigator.clipboard.writeText(b.dataset.aeCopy); b.textContent = 'Copied'; }
    catch (_) {
      // Clipboard blocked: highlight the code so it can be copied by hand
      const val = b.parentElement.querySelector('.ae-news__code-val');
      if (val) { const r = document.createRange(); r.selectNodeContents(val); const sel = getSelection(); sel.removeAllRanges(); sel.addRange(r); }
      b.textContent = 'Press Ctrl/⌘ C';
    }
    setTimeout(() => { b.textContent = 'Copy'; }, 2000);
  });

  /* ---------- UGC reels: play only while on screen; no autoplay for reduced motion ---------- */
  const reels = $$('[data-ae-reel]');
  if (reels.length) {
    const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    reels.forEach((v) => { v.muted = true; v.setAttribute('playsinline', ''); });
    if (still) {
      reels.forEach((v) => { v.controls = true; });
    } else if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => entries.forEach((en) => {
        const v = en.target;
        if (en.isIntersecting) { if (v.preload === 'none') v.preload = 'auto'; v.play().catch(() => {}); }
        else v.pause();
      }), { threshold: 0.35 });
      reels.forEach((v) => io.observe(v));
    }
  }

  /* ---------- Search bar (desktop header): live product suggestions ---------- */
  const sbar = $('#ae-search');
  if (sbar) {
    const toggle = $('[data-ae-search-toggle]');
    const input = $('[data-ae-search-input]', sbar);
    const out = $('[data-ae-search-results]', sbar);
    let timer, ctrl;
    const openSearch = () => { sbar.hidden = false; toggle && toggle.setAttribute('aria-expanded', 'true'); setTimeout(() => input.focus(), 30); };
    const closeSearch = () => { sbar.hidden = true; toggle && toggle.setAttribute('aria-expanded', 'false'); };
    toggle && toggle.addEventListener('click', () => (sbar.hidden ? openSearch() : closeSearch()));
    $('[data-ae-search-close]', sbar).addEventListener('click', () => { closeSearch(); toggle && toggle.focus(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !sbar.hidden) { closeSearch(); toggle && toggle.focus(); } });
    document.addEventListener('click', (e) => { if (!sbar.hidden && !sbar.contains(e.target) && !e.target.closest('[data-ae-search-toggle]')) closeSearch(); });
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (!q) { out.innerHTML = ''; return; }
      timer = setTimeout(async () => {
        try {
          ctrl && ctrl.abort(); ctrl = new AbortController();
          const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`, { signal: ctrl.signal });
          const data = await res.json();
          const items = (data.resources && data.resources.results && data.resources.results.products) || [];
          const all = `<a class="ae-sr__all" href="/search?type=product&q=${encodeURIComponent(q)}">See all results</a>`;
          if (!items.length) { out.innerHTML = `<p class="ae-sr__empty">No products match “${esc(q)}”.</p><div class="ae-sr__foot"><span></span>${all}</div>`; return; }
          out.innerHTML = `<div class="ae-sr__grid">${items.map((p) => {
            const img = p.image ? `${p.image}${p.image.includes('?') ? '&' : '?'}width=360` : '';
            const pmin = Math.round(parseFloat(p.price_min || p.price || '0') * 100);
            const pmax = Math.round(parseFloat(p.price_max || p.price || '0') * 100);
            const price = pmin;
            return `<a class="ae-sr__item" href="${esc(p.url)}"><span class="ae-sr__img">${img ? `<img src="${esc(img)}" alt="" loading="lazy">` : ''}</span><span class="ae-sr__name">${esc(p.title)}</span><span class="ae-sr__price">${p.available === false ? 'Sold out' : (pmax > pmin ? 'From ' : '') + money(price)}</span></a>`;
          }).join('')}</div><div class="ae-sr__foot"><span>${items.length} product${items.length === 1 ? '' : 's'}</span>${all}</div>`;
        } catch (err) { if (err.name !== 'AbortError') out.innerHTML = ''; }
      }, 180);
    });
  }

  /* ---------- Site-wide: product pages and the cart page use the old theme's cart code ---------- */
  // product-form.js looks for <cart-drawer>; this stand-in sends its add-to-cart to the new bag drawer.
  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', class extends HTMLElement {
      getSectionsToRender() { return []; }
      setActiveElement() {}
      renderContents() { openDrawer('ae-bag'); }
      open() { openDrawer('ae-bag'); }
    });
  }
  document.addEventListener('cart:change', refreshCart);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, () => refreshCart());

  refreshCart();
})();
